import { render, staticRenderFns } from "./UpsellingBanner.vue?vue&type=template&id=28e3f7a1&scoped=true&"
import script from "./UpsellingBanner.vue?vue&type=script&lang=ts&"
export * from "./UpsellingBanner.vue?vue&type=script&lang=ts&"
import style0 from "./UpsellingBanner.vue?vue&type=style&index=0&id=28e3f7a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3f7a1",
  null
  
)

export default component.exports